<template>
  <!--内容-->
  <div class="bodybox cursorstyle">
    <ApprovalPage></ApprovalPage>
    <!--  第一部分-->
    <div class="bodybox_modular stylePointer" style="margin-top: 2.5vh;">
      <div>
        <!-- <div class="bodybox_modular_bg">
          <img src="../assets/homeImg/home1.png">
        </div> -->
        <div class="bodybox_modular_box">
          <p>专利申报</p>
          <div class="bodybox_modular_tx">
            专利：专利是受法律规范保护的发明创造，是指一项发明创造向国家审批机关提出专利申请，经依法审查合格后，向专利申请人授予的在规定的时间内对该项发明创造享有的专有权。这种权利具有独占的排他性。非专利权人要想使用他人的专利技术，必须依法征得专利权人的同意或许可。在我国，专利分为发明、实用新型和外观设计三种类型。 </div>
          <div class="bodybox_modular_go bodybox_modular_gox cursorstyleObjBtn" @click="EnterBtn('patent')">去申请>></div>
        </div>
      </div>
      <div class="hrrs">
      </div>
      <div>
        <!-- <div class="bodybox_modular_bg">
          <img src="../assets/homeImg/位图 2.png">
        </div> -->
        <div class="bodybox_modular_box">
          <p>商标注册申报</p>
          <div class="bodybox_modular_tx">
            商标：商标是指商标所有人为了取得商标专用权，依照国家规定的注册条件、原则和程序，向商标局提出注册申请，商标局经过审核，准予注册的法律事实。经商标局审核注册的商标，便是注册商标，享有商标专用权。 </div>
          <div class="bodybox_modular_go cursorstyleObjBtn" @click="EnterBtn('trademark')">去申请>></div>
        </div>
      </div>
      <div class="hrrs">
      </div>
      <div>
        <!-- <div class="bodybox_modular_bg">
          <img src="../assets/homeImg/位图 3.png">
        </div> -->
        <div class="bodybox_modular_box">
          <p>软件著作权（版权）申报</p>
          <div class="bodybox_modular_tx">
            著作权（版权）：著作权是指著作权人对其创作的文学、艺术和科学作品等智力成果依法享有的专有权利。著作权通常有广义和狭义之分：狭义的著作权，仅指作者对其作品依法享有的权利;广义的著作权既包括狭义的著作权内容，还包括著作邻接权，即作品传播者依法享有的权利，如艺术表演者的权利、录音录像制品制作者的权利、广播电视组织的权利、图书和报刊出版者的权利等。 </div>
          <div class="bodybox_modular_go cursorstyleObjBtn" @click="EnterBtn('soft')">去申请>></div>
        </div>
      </div>
    </div>
    <!--  电子申请流程-->
    <div class="bodybox_Electronics stylePointer">
      <p>电子申请流程</p>
      <div>
        <svg width="100%" height="100%" viewBox="0 0 1180 340" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="首页-工作台-待审批" transform="translate(-380.000000, -1615.000000)">
              <g id="编组-9" transform="translate(380.000000, 1616.000000)">
                <g id="编组-13" transform="translate(0.000000, 20.060207)">
                  <path
                      d="M136,2.28705943e-13 C136.626014,2.29150032e-13 137.236346,0.195834761 137.74549,0.560068388 L194.589343,41.2252866 C195.93688,42.1892938 196.247792,44.0631707 195.283785,45.4107077 C195.092022,45.6787632 194.857398,45.913387 194.589343,46.1051498 L137.74549,86.770368 C136.397953,87.7343752 134.524076,87.4234629 133.560068,86.0759259 C133.195835,85.5667821 133,84.9564504 133,84.3304364 L133,75.697 L3,75.6970634 C1.34314575,75.6970634 2.02906125e-16,74.3539176 0,72.6970634 L0,15.6970634 C-6.46995335e-16,14.0402091 1.34314575,12.6970634 3,12.6970634 L133,12.697 L133,3 C133,1.34314575 134.343146,2.28705943e-13 136,2.28705943e-13 Z"
                      id="形状结合" fill="#0F7C63"></path>
                  <text id="前期咨询" font-family="MicrosoftYaHei-Bold, Microsoft YaHei" font-size="14"
                        font-weight="bold" fill="#FFFFFF">
                    <tspan x="48" y="48.9397927">前期咨询</tspan>
                  </text>
                </g>
                <g id="编组-13" transform="translate(203.666667, 20.060207)">
                  <path
                      d="M292.333333,2.28705943e-13 C292.959347,2.29150032e-13 293.569679,0.195834761 294.078823,0.560068388 L350.922676,41.2252866 C352.270213,42.1892938 352.581126,44.0631707 351.617118,45.4107077 C351.425356,45.6787632 351.190732,45.913387 350.922676,46.1051498 L294.078823,86.770368 C292.731286,87.7343752 290.857409,87.4234629 289.893402,86.0759259 C289.529168,85.5667821 289.333333,84.9564504 289.333333,84.3304364 L289.333,75.165 L3,75.1652182 C1.34314575,75.1652182 2.02906125e-16,73.8220724 0,72.1652182 L0,15.1652182 C-2.02906125e-16,13.5083639 1.34314575,12.1652182 3,12.1652182 L289.333,12.165 L289.333333,3 C289.333333,1.34314575 290.676479,2.28705943e-13 292.333333,2.28705943e-13 Z"
                      id="形状结合" fill="#0F7C63"></path>
                  <text id="登陆北京中医药知识产权保护服务-管理平台" font-family="MicrosoftYaHei-Bold, Microsoft YaHei"
                        font-size="14" font-weight="bold" fill="#FFFFFF">
                    <tspan x="47" y="40.1652182">登陆北京中医药知识产权保护服务</tspan>
                    <tspan x="47" y="59.1652182">管理平台下载相关表格</tspan>
                  </text>
                </g>
                <g id="编组-13" transform="translate(561.333333, 20.060207)">
                  <path
                      d="M291.666667,2.28705943e-13 C292.292681,2.29150032e-13 292.903012,0.195834761 293.412156,0.560068388 L350.25601,41.2252866 C351.603547,42.1892938 351.914459,44.0631707 350.950452,45.4107077 C350.758689,45.6787632 350.524065,45.913387 350.25601,46.1051498 L293.412156,86.770368 C292.064619,87.7343752 290.190742,87.4234629 289.226735,86.0759259 C288.862501,85.5667821 288.666667,84.9564504 288.666667,84.3304364 L288.666,75.165 L3,75.1652182 C1.34314575,75.1652182 2.02906125e-16,73.8220724 0,72.1652182 L0,15.1652182 C-2.02906125e-16,13.5083639 1.34314575,12.1652182 3,12.1652182 L288.666,12.165 L288.666667,3 C288.666667,1.34314575 290.009812,2.28705943e-13 291.666667,2.28705943e-13 Z"
                      id="形状结合" fill="#0F7C63"></path>
                  <text id="填写申报材料并上传至管理平台" font-family="MicrosoftYaHei-Bold, Microsoft YaHei"
                        font-size="14" font-weight="bold" fill="#FFFFFF">
                    <tspan x="58" y="49.1652182">填写申报材料并上传至管理平台</tspan>
                  </text>
                </g>
                <g id="编组-13" transform="translate(929.000000, 32.000000)">
                  <rect id="矩形" fill="#0F7C63" x="0" y="0" width="160" height="63" rx="3"></rect>
                  <text id="材料初审" font-family="MicrosoftYaHei-Bold, Microsoft YaHei" font-size="14"
                        font-weight="bold" fill="#FFFFFF">
                    <tspan x="52" y="37">材料初审</tspan>
                  </text>
                </g>
                <g id="编组-13" transform="translate(752.155915, 250.591821)">
                  <path
                      d="M62.2840162,1.25474163 C62.6482498,1.76388541 62.8440845,2.37421718 62.8440845,3.00023117 L62.844,11.165 L333.844085,11.1654494 C335.500939,11.1654494 336.844085,12.5085951 336.844085,14.1654494 L336.844085,71.1654494 C336.844085,72.8223036 335.500939,74.1654494 333.844085,74.1654494 L62.844,74.165 L62.8440845,84.3306675 C62.8440845,85.9875218 61.5009388,87.3306675 59.8440845,87.3306675 C59.2180705,87.3306675 58.6077388,87.1348328 58.098595,86.7705991 L1.25474163,46.105381 C-0.0927953862,45.1413737 -0.403707693,43.2674968 0.56029956,41.9199598 C0.752062332,41.6519043 0.986686146,41.4172805 1.25474163,41.2255177 L58.098595,0.56029956 C59.446132,-0.403707693 61.3200089,-0.0927953862 62.2840162,1.25474163 Z"
                      id="形状结合" fill="#0F7C63"></path>
                  <text id="材料复审" font-family="MicrosoftYaHei-Bold, Microsoft YaHei" font-size="14"
                        font-weight="bold" fill="#FFFFFF">
                    <tspan x="139.844085" y="48.1654494">材料复审</tspan>
                  </text>
                </g>
                <g id="编组-13" transform="translate(452.155915, 250.591821)">
                  <path
                      d="M62.2840162,1.25474163 C62.6482498,1.76388541 62.8440845,2.37421718 62.8440845,3.00023117 L62.844,11.165 L287.844085,11.1654494 C289.500939,11.1654494 290.844085,12.5085951 290.844085,14.1654494 L290.844085,71.1654494 C290.844085,72.8223036 289.500939,74.1654494 287.844085,74.1654494 L62.844,74.165 L62.8440845,84.3306675 C62.8440845,85.9875218 61.5009388,87.3306675 59.8440845,87.3306675 C59.2180705,87.3306675 58.6077388,87.1348328 58.098595,86.7705991 L1.25474163,46.105381 C-0.0927953862,45.1413737 -0.403707693,43.2674968 0.56029956,41.9199598 C0.752062332,41.6519043 0.986686146,41.4172805 1.25474163,41.2255177 L58.098595,0.56029956 C59.446132,-0.403707693 61.3200089,-0.0927953862 62.2840162,1.25474163 Z"
                      id="形状结合" fill="#0F7C63"></path>
                  <text id="上报国家知识产权局" font-family="MicrosoftYaHei-Bold, Microsoft YaHei"
                        font-size="14" font-weight="bold" fill="#FFFFFF">
                    <tspan x="109.844085" y="48.1654494">上报国家知识产权局</tspan>
                  </text>
                </g>
                <g id="编组-13" transform="translate(202.155915, 250.591821)">
                  <path
                      d="M62.2840162,1.25474163 C62.6482498,1.76388541 62.8440845,2.37421718 62.8440845,3.00023117 L62.844,11.165 L234.844085,11.1654494 C236.500939,11.1654494 237.844085,12.5085951 237.844085,14.1654494 L237.844085,71.1654494 C237.844085,72.8223036 236.500939,74.1654494 234.844085,74.1654494 L62.844,74.165 L62.8440845,84.3306675 C62.8440845,85.9875218 61.5009388,87.3306675 59.8440845,87.3306675 C59.2180705,87.3306675 58.6077388,87.1348328 58.098595,86.7705991 L1.25474163,46.105381 C-0.0927953862,45.1413737 -0.403707693,43.2674968 0.56029956,41.9199598 C0.752062332,41.6519043 0.986686146,41.4172805 1.25474163,41.2255177 L58.098595,0.56029956 C59.446132,-0.403707693 61.3200089,-0.0927953862 62.2840162,1.25474163 Z"
                      id="形状结合" fill="#0F7C63"></path>
                  <text id="领取证书" font-family="MicrosoftYaHei-Bold, Microsoft YaHei" font-size="14"
                        font-weight="bold" fill="#FFFFFF">
                    <tspan x="118.844085" y="48.1654494">领取证书</tspan>
                  </text>
                </g>
                <g id="编组-13" transform="translate(0.000000, 262.000000)">
                  <path
                      d="M3,0 L187,0 C188.656854,-3.04359188e-16 190,1.34314575 190,3 L190,60 C190,61.6568542 188.656854,63 187,63 L3,63 C1.34314575,63 2.02906125e-16,61.6568542 0,60 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 Z"
                      id="矩形" fill="#0F7C63"></path>
                  <text id="流程结束" font-family="MicrosoftYaHei-Bold, Microsoft YaHei" font-size="14"
                        font-weight="bold" fill="#FFFFFF">
                    <tspan x="67" y="37">流程结束</tspan>
                  </text>
                </g>
                <g id="编组-14" transform="translate(927.862915, 145.362915)">
                  <polygon id="矩形" fill="#0F7C63"
                           points="79.137085 -2.21327986e-14 160.27417 35.137085 79.137085 69.27417 -1.0922966e-12 35.137085">
                  </polygon>
                  <text id="是否通过" font-family="MicrosoftYaHei-Bold, Microsoft YaHei" font-size="14"
                        font-weight="bold" fill="#FFFFFF">
                    <tspan x="52" y="40">是否通过</tspan>
                  </text>
                </g>
                <polyline id="路径-11" stroke="#0F7C63" stroke-width="2"
                          points="1082 180 1157.5 180 1157.5 6.39488462e-13 711 4.54747351e-13 711 28">
                </polyline>
                <path id="直线-11"
                      d="M1007,212 L1007,250.999 L1011,251 L1006.5,260 L1002,251 L1006,250.999 L1006,212 L1007,212 Z"
                      fill="#0F7C63" fill-rule="nonzero"></path>
                <text id="是" font-family="MicrosoftYaHei, Microsoft YaHei" font-size="14"
                      font-weight="normal" fill="#333333">
                  <tspan x="1018" y="237">是</tspan>
                </text>
                <path id="直线-11"
                      d="M1007,95 L1007,133.999 L1011,134 L1006.5,143 L1002,134 L1006,133.999 L1006,95 L1007,95 Z"
                      fill="#0F7C63" fill-rule="nonzero"></path>
                <text id="否" font-family="MicrosoftYaHei, Microsoft YaHei" font-size="14"
                      font-weight="normal" fill="#333333">
                  <tspan x="1166" y="88">否</tspan>
                </text>
                <path id="直线-11" d="M711,31.5 L715.5,22.5 L706.5,22.5 L711,31.5 Z" fill="#0F7C63"
                      fill-rule="nonzero"></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <!--  分割线-->
    <div class="hrhr"></div>
    <!--  通知公告-->
    <div class="bodybox_Notice ">
      <div class="bodybox_Notice_box stylePointer cursorstyleObjBtn">
        <div @click="changBtn('1')" :class="this.type == '1' ?'first-child':' '">通知公告</div>
        <div @click="changBtn('3')" :class="this.type == '3' ?'first-child':' '">相关规范</div>
        <div @click="changBtn('4')" :class="this.type == '4' ?'first-child':' '">常用表格</div>
      </div>
    </div>
    <!-- 公告模块-->
    <div class="Notice_box stylePointer">
      <div class="Notice_box_tpl">
        <div></div>
        <div>
          <el-table :data="tableData" @row-click="openDetails">
            <el-table-column label="标题" align="left">
              <template slot-scope="scope">
                <div @click="Noticebtn()">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="发布时间" align="center" width="130px">
              <template slot-scope="scope">
                <span>{{ userObj.dateFormat(scope.row.create_time) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="view_count" label="浏览次数" align="center" width="100px">
              <template slot-scope="scope">
                {{ scope.row.view_count }}
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  GetlistinformationInterface
} from "@/api/ApplicationManagement.js"

import ApprovalPage from './home/ApprovalPage.vue'

export default {
  data() {
    return {
      tableData: [],
      // 类型
      type: '1'
    }
  },
  components: {
    ApprovalPage
  },
  mounted() {
    this.Getlistinformation()
  },
  methods: {
    openDetails(row) {
       if(row.type!=4){
         this.$router.push({
           path: './NoticeDetails',
           query: {
             type: this.type,
             ids: row.id
           }
         })
       }

    },
    changBtn(val) {
      this.type = val
      this.Getlistinformation()
    },
    async Getlistinformation() {
      let obj = {
        type: this.type,
        show_position: 1
      }
      let res = await GetlistinformationInterface(obj)
      if (res.code == "00000") {
        this.tableData = res.data.result
        this.total_count = 50
      }
    },

    // 录入按钮
    EnterBtn(value) {
      // // 如果不是登录状态，跳转到登录页面
      // if (this.userObj.info() == null) {
      // 	this.coverBox = true
      // 	return
      // }
      // // 登录状态进行
      // else if (value == 'patent') {
      // 	this.$router.push('./patentSeeMore')
      // } else if (value == 'trademark') {
      // 	this.$router.push('./trademarkSeeMore')
      // } else if (value == 'soft') {
      // 	this.$router.push('./softSeeMore')
      // }

      if (value == 'patent') {
        this.$router.push('./patentApplication')
      } else if (value == 'trademark') {
        this.$router.push('./TrademarkApplication')
      } else if (value == 'soft') {
        this.$router.push('./SoftApply')
      }
    },
  }
}
</script>

<style scoped="scoped" lang="less">
/*内容*/
.bodybox {
  width: 63vw;
  margin: 0 auto;
  margin-top: 20px;
  /*border: green solid 1px;*/
}

/*第一部分*/
.bodybox_modular {
  /*display: flex;*/
}

.bodybox_modular > div {
  /*margin-right: 22px;*/
  /*background: #FFFFFF;*/
  display: flex;
  // margin-top: 10px;
}

.hrrs {
  height: 1px;
  background: #E5E5E5;
  margin-top: 2vh;
  margin-bottom: 2vh;

}

.bodybox_modular > div > .bodybox_modular_bg {
  width: 18.9vw;
  height: 15.5vh;
  background: #D8D8D8;
  border-radius: 5px;
}

.bodybox_modular > div > .bodybox_modular_bg {
  img {
    width: 100%;
    height: 100%;
  }
}

.bodybox_modular > div > .bodybox_modular_box {
  // width: 40.7vw;
  margin-left: 15px;
  position: relative;
  flex: 1;

}

.bodybox_modular > div .bodybox_modular_tx {
  padding-left: 10px;
  margin-top: 5px;
  text-indent: 15px;
  color: #666666;
  font-size: 0.87rem;
}

.bodybox_modular > div .bodybox_modular_go {
  font-size: 0.87rem;
  color: #EA6911;
  float: right;
  margin-right: 5px;
  margin-top: 3px;

}

.bodybox_modular > div .bodybox_modular_gox {
  font-size: 0.87rem;
  color: #EA6911;
  float: right;
  margin-right: 5px;
  margin-top: 3px;
}

.bodybox_modular > div p {
  color: #333333;
  padding-left: 10px;
  font-size: 1rem;
  font-weight: bold;
  color: #333333;
  line-height: 21px;
}

/*电子*/
.bodybox_Electronics {
  margin-top: 20px;
}

.bodybox_Electronics > p {
  color: #333333;
  font-size: 1.13rem;
  font-weight: bold;
}

.bodybox_Electronics > div {
  width: 98%;
  margin: 0 auto;
  margin-top: 10px;
}

.hrhr {
  width: 100%;
  height: 1px;
  background: #E5E5E5;
  margin-top: 20px;
}

.bodybox_Notice {
  border-bottom: 1px #E5E5E5 solid;
  margin-top: 20px;
}

.bodybox_Notice_box {
  width: 304px;
  display: flex;
  margin-left: 10px;
}

.bodybox_Notice_box > div {
  width: calc((100% - 75px) / 3);
  margin-right: 39px;
  height: 45px;
  text-align: center;
  color: #333333;
  font-size: 1.13rem;
}

.bodybox_Notice_box > div:last-of-type {
  margin-right: 0px;
}

.first-child {
  font-weight: bold;
  border-bottom: #07604E solid 1px;
  color: #333333;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #07604E;
}

.Notice_box {
  margin-top: 20px;
  //border: 1px solid red;
}

.Notice_box_tpl {
  width: 98%;
  display: flex;
  margin: 0 auto;
}

.Notice_box_tpl > div {
  width: calc((100% - 15px) / 2);
  margin-right: 20px;
  height: 290px;
  overflow: hidden;
  //border: 1px solid green;
}

/deep/ .el-table th {
  height: 30px;
}

/deep/ .el-table__body td {
  height: 30px;
  //border: 1px solid red;
}

.Notice_box_tpl > div:last-of-type {
  margin-right: 0px;
}

.Notice_box_tpl > div:first-child {
  /* height: 212px; */
  background: #D8D8D8;
  border-radius: 5px;
  background: url(../assets/homeImg/bottomlistbg.png) no-repeat center;
  background-size: 100% 100%;
}

.Notice_box_tpl > div:nth-child(2) > ul li {
  list-style: none;
  font-size: 0.88rem;
  color: #999999;
  height: 29px;
  line-height: 29px;
  border-bottom: 1px dotted #E5E5E5;
  margin-top: 10px;
}

.Notice_box_tpl > div:nth-child(2) > ul li:first-child {
  margin-top: 0px;
}

.Notice_box_tpl > div:nth-child(2) > ul li > .item_time {
  float: right;
  margin-right: 10px;
}

/deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
  cursor:pointer !important;
}
</style>
